import { settings } from '@/main/config/settings'

export type LinkConstantType = {
  name: string
  url: string
}

type LinkConstantsType = {
  [key: string]: LinkConstantType
}

export const LinkConstants: LinkConstantsType = {
  SUPPORT: {
    name: 'support',
    url: settings.SUPPORT_URL
  },
  PRIVACY_POLICY: {
    name: 'privacyPolicy',
    url: settings.SKILL_PRIVACY_POLICY_URL
  },
  COMPANY_POLITICS: {
    name: 'companyPolitics',
    url: ''
  },
  TERMS_OF_USE: {
    name: 'termsOfUse',
    url: settings.SKILL_TERMS_OF_USE_URL
  },
  SOCIAL_MEDIA_LINKED_IN: {
    name: 'socialMediaLinkedin',
    url: settings.SKILL_SOCIAL_MEDIA_LINKEDIN
  },
  SOCIAL_MEDIA_INSTAGRAM: {
    name: 'socialMediaInstagram',
    url: settings.SKILL_SOCIAL_MEDIA_INSTAGRAM
  },
  EXTERNAL_CATALOG: {
    name: 'externalCatalog',
    url: settings.SKILL_EXTERNAL_CATALOG_URL
  }
}
